// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import ShieldSvg from '@rsuite/icon-font/lib/application/Shield';
var Shield = createSvgIcon({
  as: ShieldSvg,
  ariaLabel: 'shield',
  category: 'application',
  displayName: 'Shield'
});
export default Shield;